<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800px">
    <template v-slot:title>Update Status</template>
    <service-status-list-select
      :is-disabled="false"
      @onSelect="onSelect"
      :outlined="outlinedInputs"
      :allowed-status-names="allowedStatusNames"
    ></service-status-list-select>
    <template v-slot:actions>
      <v-btn color="primary" @click="onUpdate">Update</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";
import ServiceStatusListSelect from "../../../shared/ServiceStatusListSelect";
export default {
  name: "update-status-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    // #11287 part 1b: restrict the selectable statuses (e.g. seller MP service
    // at "Requested by MP" → Confirmed/Rejected only)
    allowedStatusNames: {
      type: Array,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    ServiceStatusListSelect,
  },

  data() {
    return {
      debug: false,
      status: { id: "U2VydmljZVN0YXR1cy0x", name: "Quotation" },
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onUpdate() {
      this.$emit("update", { ...this.status });
    },
    onSelect(payload) {
      this.status = { ...payload };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/UpdateStatusDialog.vue